/**
 * Constants.ts
 *
 * A module for all the constants.
 */

/**
 * Telemetry events
 */
export class TelemetryEvent {
	public static CampaignState = class {
		public static Deserialize = class {
			public static Failed = "FloodgateCore_CampaignState_Deserialize_Failed";
		};
	};

	public static FileBasedCampaignStateProvider = class {
		public static Load = class {
			public static Failed = "FloodgateCore_FileBasedCampaignStateProvider_Load_Failed";
		};
	};

	public static HostBasedCampaignStateProvider = class {
		public static GetStatesFromHost = class {
			public static Failed = "FloodgateCore_HostBasedCampaignStateProvider_GetStatesFromHost_Failed";
		};
	};

	public static Floodgate = class {
		public static Initialize = class {
			public static Failed = "FloodgateCore_Floodgate_Initialize_Failed";
		};

		public static Start = class {
			public static Failed = "FloodgateCore_Floodgate_Start_Failed";
			public static Warning = "FloodgateCore_Floodgate_Start_Warning";
			public static SurveysDisabled = "FloodgateCore_Floodgate_Start_SurveysDisabled";
			public static MessagingDisabled = "FloodgateCore_Floodgate_Start_MessagingDisabled";
			public static DynamicCampaignEnabled = "FloodgateCore_Floodgate_Start_DynamicCampaignEnabled";
			public static DynamicCampaignClientUndefined = "FloodgateCore_Floodgate_Start_DynamicCampaignClientUndefined";
		};

		public static UserFactsLoad = class {
			public static Failed = "FloodgateCore_Floodgate_UserFactsLoad_Failed";
		};

		public static UserFactsSpecDeserialization = class {
			public static Failed = "FloodgateCore_Floodgate_UserFactsSpecDeserialization_Failed";
		};

		public static UserFactsSpecIsAMatch = class {
			public static Failed = "FloodgateCore_Floodgate_UserFactsSpecIsAMatch_Failed";
			public static Mismatch = "FloodgateCore_Floodgate_UserFactsSpecIsAMatch_Mismatch";
			public static Summary = "FloodgateCore_Floodgate_UserFactsSpecIsAMatch_Summary";
		};

		public static RenderSurvey = class {
			public static Unsupported = "FloodgateCore_Floodgate_RenderSurvey_Unsupported";
		};
	};

	public static FloodgateEngine = class {
		public static Make = class {
			public static Failed = "FloodgateCore_FloodgateEngine_Make_Failed";
		};

		public static Common = class {
			public static Error = "FloodgateCore_FloodgateEngine_Common_Error";
			public static ActiveSurveys = "FloodgateCore_FloodgateEngine_Common_ActiveSurveys";
		};

		public static Start = class {
			public static Failed = "FloodgateCore_FloodgateEngine_Start_Failed";
		};

		public static StartAsync = class {
			public static Failed = "FloodgateCore_FloodgateEngine_StartAsync_Failed";
			public static Stopped = "FloodgateCore_FloodgateEngine_StartAsync_Stopped";
		};

		public static InitialLoadedDefinitions = "FloodgateCore_FloodgateEngine_InitialLoadedDefinitions";
		public static CampaignTypeDisabledDefinitions = "FloodgateCore_FloodgateEngine_CampaignTypeDisabledDefinitions";
		public static CampaignInitialTriggerMet = "FloodgateCore_FloodgateEngine_CampaignInitialTriggerMet";
		public static GetActiveSurveys = "FloodgateCore_FloodgateEngine_GetActiveSurveys";

		public static OnSurveyActivated = class {
			public static ActivationStatsSuppressedSurvey = "FloodgateCore_FloodgateEngine_OnSurveyActivated_ActivationStatsSuppressedSurvey";
			public static ClosedChannelType = "FloodgateCore_FloodgateEngine_OnSurveyActivated_ClosedChannelType";
			public static SurveyNotDefined = "FloodgateCore_FloodgateEngine_OnSurveyActivated_SurveyNotDefined";
			public static SessionSuppressedSurvey = "FloodgateCore_FloodgateEngine_OnSurveyActivated_SessionSuppressedSurvey";
			public static ActivationExpiredSurvey = "FloodgateCore_FloodgateEngine_OnSurveyActivated_ActivationExpiredSurvey";
			public static ActivationIrrelevantSurvey = "FloodgateCore_FloodgateEngine_OnSurveyActivated_ActivationIrrelevantSurvey";
			public static Error = "FloodgateCore_FloodgateEngine_OnSurveyActivated_Error";
		};

		public static CheckGovernanceServiceAndActivateSurvey = class {
			public static GovernanceServiceForceToDisplay = "FloodgateCore_FloodgateEngine_GovernanceService_GovernanceServiceForceToDisplay";
			public static GovernanceServiceClientCompleted = "FloodgateCore_FloodgateEngine_GovernanceService_GovernanceServiceClientCompleted";
			public static GovernanceServiceSurveyInCooldown = "FloodgateCore_FloodgateEngine_GovernanceService_GovernanceServiceSurveyInCooldown";
		};
		
		public static QueryTriggerMetApisAsync = class {
			public static Exception = "FloodgateCore_FloodgateEngine_QueryTriggerMetApisAsync_Exception";
			public static QueryTriggerMetApisAsync = "FloodgateCore_FloodgateEngine_QueryTriggerMetApisAsync";
			public static SurveyCdnFailureConcurrently = "FloodgateCore_FloodgateEngine_QueryTriggerMetApisAsync_SurveyCdnFailureConcurrently";
			public static SurveyCdnFailureSequentially = "FloodgateCore_FloodgateEngine_QueryTriggerMetApisAsync_SurveyCdnFailureSequentially";
		};
	};

	public static GovernedChannelState = class {
		public static Deserialize = class {
			public static Failed = "FloodgateCore_GovernedChannelState_Deserialize_Failed";
		};
	};

	public static FileBasedGovernedChannelStateProvider = class {
		public static Load = class {
			public static Failed = "FloodgateCore_FileBasedGovernedChannelStateProvider_Load_Failed";
		};
	};

	public static HostBasedGovernedChannelStateProvider = class {
		public static GetStatesFromHost = class {
			public static Failed = "FloodgateCore_HostBasedGovernedChannelStateProvider_GetStatesFromHost_Failed";
		};
	};

	public static SurveyStatCollectionActivation = class {
		public static FromJson = class {
			public static Failed = "FloodgateCore_SurveyStatCollectionActivation_FromJson_Failed";
		};

		public static ToJson = class {
			public static Failed = "FloodgateCore_SurveyStatCollectionActivation_ToJson_Failed";
		};
	};

	public static HostBasedSurveyActivationStatsProvider = class {
		public static GetSurveyStatsFromHost = class {
			public static Failed = "FloodgateCore_HostBasedSurveyActivationStatsProvider_GetSurveyStatsFromHost_Failed";
		};
	};

	public static SurveyStatCollectionEventActivity = class {
		public static FromJson = class {
			public static Failed = "FloodgateCore_SurveyStatCollectionEventActivity_FromJson_Failed";
		};

		public static ToJson = class {
			public static Failed = "FloodgateCore_SurveyStatCollectionEventActivity_ToJson_Failed";
		};
	};

	public static SurveyActivity = class {
		public static LogActivity = class {
			public static EventsReprocessed = "FloodgateCore_SurveyActivity_LogActivity_EventsReprocessed";
			public static SurveysReprocessed = "FloodgateCore_SurveyActivity_LogActivity_SurveysReprocessed";
		};

		public static SetActivityTrackingContracts = class {
			public static DuplicateSurveyID = "FloodgateCore_SurveyActivity_SetActivityTrackingContracts_DuplicateSurveyID";
		};
	};

	public static DynamicCampaignDefinitionProvider = class {
		public static Load = class {
			public static EmptyEcsConfig = "FloodgateCore_DynamicCampaignDefinitionProvider_Load_EmptyEcsConfig";
			public static InvalidEcsConfig = "FloodgateCore_DynamicCampaignDefinitionProvider_Load_InvalidEcsConfig";
		};
	};

	public static CampaignDefinitionProvider = class {
		public static CampaignSurveyTemplate = class {
			public static SchemaValidationError = "FloodgateCore_CampaignDefinitionProvider_CampaignSurveyTemplate_validate";
		};
	};

	public static CampaignGovernance = class {
		public static LogExperimentTrigger = class {
			public static Undefined = "FloodgateCore_CampaignGovernance_LogExperimentTrigger_Undefined";	
			public static Failed = "FloodgateCore_CampaignGovernance_LogExperimentTrigger_Failed";	
		}
		public static RetrieveTriggerEventDetail = class {
			public static Failed = "FloodgateCore_CampaignGovernance_RetrieveTriggerEventDetail_Failed";	
		};
		public static NominationCheckCampaigns = "FloodgateCore_CampaignGovernance_NominationCheckCampaigns";
	};

	public static HttpTransport = class {
		public static GET = class {
			public static Success = "HttpTransport_Get_Success";
			public static Error = "HttpTransport_Get_Error";
		}
	}

	public static FloodgateSurveyCdnClient = class {
		public static loadCdnStringResource = class {
			public static Request_Failed = "Floodgate_Survey_CDN_Request_Failed";
			public static Request_Success = "Floodgate_Survey_CDN_Request_Success";
			public static Exception = "Floodgate_Survey_CDN_Exception";
			public static Completed = "Floodgate_Survey_CDN_Completed";
		}
	}
}
